import React, { lazy, Suspense } from 'react';

const LazyApiKeyList = lazy(() => import('./ApiKeyList'));

const ApiKeyList = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyApiKeyList {...props} />
  </Suspense>
);

export default ApiKeyList;
